'use strict';



const $ = require('jquery');
const getFragment = require('./get-fragment').bind(null, 'Loan/RecentUpdates');
const $container = $('.js-updates');
const $loadingIndicator = $('.js-updates-loading');
const offset = 200;
const $window = $(window);
const relatedToUser = window.updatesFeedRelatedTouser;
const generalUpdates = window.updatesFeedGeneralUpdates;
const loanId = window.updatesFeedLoanId;
let page = 1;
let waiting = false;
let start = window.updatesFeedStart;
let done = false;
let rerender;



(function() {

	if($container.length < 1 || !start) {
		return;
	}

	rerender = setInterval(maybeGetNextPage, 500);
	maybeGetNextPage();

})();



function maybeGetNextPage() {

	if(done) {
		if(rerender) {
			clearTimeout(rerender);
		}
		return;
	}

	const $latestItem = $('.js-updates-item').last();

	if($latestItem.offset().top - offset <= $window.height() + $window.scrollTop()) {
		getNextPage();
	}

}



function getNextPage() {

	if(done || waiting) {
		return;
	}

	waiting = true;

	startLoading();

	getFragment({ start, page, relatedToUser, generalUpdates, loanId })
		.done(res => {

			waiting = false;
			setTimeout(maybeEndLoading, 1000);

			if(!res) {
				done = true;
				return;
			}

			page ++;
			appendFeed(res);
			maybeGetNextPage();

		});

}



function appendFeed(feed) {

	const $feed = $(feed);

	$feed.each(function(i) {

		const $item = $(this);
		$item.addClass('is-pre-load');

		setTimeout(() => {
			$item.removeClass('is-pre-load');
			$item.addClass('is-post-load');
		}, 100 * i);

	});

	$container.append($feed);

}



function startLoading() {
	$loadingIndicator.removeClass('is-inactive');
	$loadingIndicator.addClass('is-active');
}



function endLoading() {
	$loadingIndicator.removeClass('is-active');
	$loadingIndicator.addClass('is-inactive');
}



function maybeEndLoading() {
	if(!waiting) {
		endLoading();
	}
}
